import useTitle from "../../../../hooks/useTitle";
import GeaoLayout from "../shared/Layout/GeaoLayout";
import { useContext, useEffect, useState } from "react";
import { GeaoContext } from "../../GeaoContextProvider";
import { getAnswer } from "../../mappers/InterviewMapper";
import useGtmTracking from "../../../../hooks/useGtmTracking";

export default function CreateYourProfileKickout() {
    useTitle("Unable to Continue Application");

    useGtmTracking("OnboardingKickout", "preonboarding_ineligible");

    const { agencyInterview, agentInterview } = useContext(GeaoContext);
    const email = getAnswer(agentInterview, "BusinessEmailAddress") || "your email address";

    const [showErrorsAndOmmissionsError, setShowErrorsAndOmmissionsError] = useState(false);
    const [showCaptiveAgentError, setShowCaptiveAgentError] = useState(false);
    const [showDoNotAppointError, setShowDoNotAppointError] = useState(false);
    const [showStateLineOfBusinessError, setShowStateLineOfBusinessError] = useState(false);
    const [showError, setShowError] = useState(false);

    useEffect(() => {
        const eoRejected = agencyInterview?.assessments?.HasErrorsAndOmmissions?.status === "Rejected";
        const captiveRejected = agentInterview?.assessments?.NotACaptiveAgent?.status === "Rejected";
        const doNotAppointRejected = agentInterview?.assessments?.NotOnDoNotAppointList?.status === "Rejected";
        const stateLineOfBusinessRejected = agencyInterview?.assessments?.StateLineOfBusinessOpen?.status === "Rejected";

        if (doNotAppointRejected) {
            setShowDoNotAppointError(true);
        } else if (captiveRejected) {
            setShowCaptiveAgentError(true);
        } else if (eoRejected) {
            setShowErrorsAndOmmissionsError(true);
        } else if (stateLineOfBusinessRejected) {
            setShowStateLineOfBusinessError(true);
        }
        else {
            setShowError(true);
        }
    }, [agencyInterview, agentInterview]);

    return (
        <GeaoLayout header="Unable to Continue Application">
            <div className="container">
                <div className="margin-top row" style={{ marginTop: "60px" }}>
                    <div className="hidden-sm col-md-3">
                        {showStateLineOfBusinessError ? (
                            <img src="images/gecko_vanna_style.png" alt="Gecko mascot" />
                        ) : (
                            <img src="images/pose.png" alt="Company Logo" />
                        )}
                    </div>
                    <div className="col-sm-12 col-md-8">
                        {showErrorsAndOmmissionsError &&
                            <li className="alert-content" style={{ marginTop: "40px" }}>
                                <div className="h3">
                                    An Errors & Omissions (E&O) Policy is required to continue.
                                </div>
                                <p>
                                    Thank you for considering GEICO For Your Agency. We're not
                                    able to move forward with your appointment because your
                                    Errors & Omissions (E&O) insurance coverage does not meet our requirements.
                                </p>
                                <p>
                                    To qualify for an appointment with GEICO, your agency needs to have an active
                                    E&O insurance policy with a $500,000 per occurrence limit/$500,000 aggregate limit.
                                </p>
                                <p>
                                    <b>Once you have the right E&O coverage, we welcome you to apply again.</b>
                                </p>
                            </li>
                        }
                        {showCaptiveAgentError &&
                            <li className="alert-content" style={{ marginTop: "40px" }}>
                                <div className="h3">
                                    Unfortunately, captive agents are ineligible for GEICO for your agency.
                                </div>
                                <p>
                                    GEICO For Your Agency requires that agents independent agents
                                    who can sell policies for multiple carriers. Captive agents
                                    selling products for a single company are ineligible.
                                </p>
                                <p>
                                    We invite you to reapply in the future if your status as a
                                    agent changes.
                                </p>
                            </li>
                        }
                        {showDoNotAppointError &&
                            <li className="alert-content" style={{ marginTop: "40px" }}>
                                <div className="h3">
                                    Unfortunately, you are not eligible for GEICO For Your Agency.
                                </div>
                                <p>
                                    Your agency does not meet our core eligibility requirements, and we're not able to move forward with your GEICO appointment.

                                    Thank you for considering GEICO For Your Agency.
                                </p>
                            </li>
                        }
                        {showStateLineOfBusinessError &&
                            <li className="alert-content" style={{ marginTop: "40px" }}>
                                <div className="h2">
                                    Thank you for completing your profile.
                                </div>
                                <p>
                                    While we’re not yet available for your agency, we can’t wait for the opportunity to partner with you!
                                </p>
                                <p>
                                    <b>We’ve saved your information and will notify you at {email} so you can be one of the first agents to quote and sell GEICO in your state.</b>
                                </p>
                            </li>
                        }
                        {showError &&
                            <li className="alert-content" style={{ marginTop: "40px" }}>
                                <div className="h2">
                                    Thank you for completing your profile.
                                </div>
                                <p>
                                    We’re sorry for the inconvenience, but it seems we are unable to continue your application at this time.
                                </p>
                                <p>
                                    Please check your email {email} for additional details.
                                </p>
                            </li>
                        }
                    </div>
                </div>
            </div>
        </GeaoLayout>
    );
}